import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { articles } from "../../articles";
import { ArticleCard } from "../../pages/Articles";
import { SectionTitle } from "./Helpers";

export default function LatestArticlesSection() {
  return (
    <section data-testid="home-latest-articles" className="py-20 bg-charcoal">
      <div className="container-narrow">
        <SectionTitle over="Conseils & guides" title="Sorcellerie, amour, protection : nos articles" />
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.slice(0, 3).map((a) => <ArticleCard key={a.slug} a={a} />)}
        </div>
        <div className="text-center mt-8">
          <Link data-testid="home-all-articles-link" to="/articles" className="btn-ghost-gold inline-flex items-center gap-1 rounded-md px-5 py-2.5 text-sm">
            Tous les articles <ChevronRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
